module.exports = __webpack_public_path__ + "static/media/logo.f067a597.png";